declare let window: any;
declare let modalService: any;
import * as React from "react";
import * as ReactDOM from "react-dom";
import { CartProduct } from './models/cart-product';

import { ElCartItemsTable } from "./Components/cart-items-table";

export class ExpertLabsCart {
    private key = '__expertlab_cart__new'
    private readonly catNumId = 'el-cart-catnum-field';
    private readonly titleId = 'el-cart-title-field';
    private get catNum(): string {
        return document.getElementById(this.catNumId)?.textContent?.trim() ?? '';
    }
    private get title(): string {
        return document.getElementById(this.titleId)?.textContent?.trim() ?? '';
    }
    private items: CartProduct[] = [];

    constructor() {
        this.read();
        this.render();
    }

    public addItem(item: CartProduct) {
        this.read()
        const index = this.items.findIndex(i => i.package == item.package && i.catNum == item.catNum);

        if (index < 0) {
            this.items.push(item);
        } else {
            this.items[index].numOfPkgs = item.numOfPkgs;
        }
        this.save();
        this.render();
    }

    public removeItem(item: CartProduct) {
        this.read();
        const index = this.items.findIndex(i => i.package == item.package && i.catNum == item.catNum);
        if (index !== -1) {
            this.items.splice(index, 1);
        }                        

        this.save();
        this.render();
    }

    public clear() {
        this.items = [];
        this.save();
        this.render();
    }

    private save() {
        localStorage.setItem(this.key, JSON.stringify(this.items));
    }

    private read() {
        var data = localStorage.getItem(this.key);
        if (!data) {
            this.items = [];
            return;
        }
        try {
            const parsed = JSON.parse(data);
            this.items = Array.isArray(parsed) ? parsed : [];
        } catch (ex) {
            this.items = [];
        }
    }

    public render() {
        const el = document.getElementById('cart_counter');
        if (!el) {
            console.warn('cant find cart element');
            return;
        }
        el.innerText = `${this.items.length}`;

        const itemsel = document.getElementById('elcart-items-container');
        if (!itemsel) {                                      
            return;
        }
        const productItems = this.items.map((i, idx) => ({ 'index': idx + 1, product: i })); 
        console.log('productItems', productItems)

        ReactDOM.render(
            <ElCartItemsTable
                items={productItems}
                onDelete={(e: CartProduct) => this.onDeleteItem(e)}
                onItemAmountChange={(number: number, p: CartProduct) => this.onChangeAmount(number, p)}/>,
            itemsel
        ); 

        this.renderTotal();
    }

    private onDeleteItem(item: CartProduct) {   
        modalService.launch('Подтвердите действие:', "Удалить позицию из заказа?", 'Да, удалить', 'Нет, оставить')
            .then((result: boolean) => {
                if (result) {
                    this.removeItem(item);
                }
            })
    }

    private onChangeAmount(number: number, item: CartProduct) {   
        item.numOfPkgs = number;
        this.save();
        this.renderTotal();
    }

    public renderTotal() {
        const hasZeroPrices = this.items.some(i => !i.price);
        const total = this.items.reduce((acc: number, item: CartProduct) => acc + item.price * item.numOfPkgs, 0)
        const text = total ? `${total}	₽ ${hasZeroPrices ? 'Цена будет уточнена менеджером после заказа' : ''}` : 'по запросу';
        document.querySelectorAll('.total-price-number').forEach(e => e.textContent = text);
    }

    public AddToCart(el: any, catNum: string, title: string, pkg: string, amount: number, price: number ) {
        if (!amount) {
            modalService.launch('Ошибка', "Вы забыли ввести необходимое количество");
            return;
        }

        this.animateAdd(el, amount.toString());

        this.addItem({
            catNum: catNum,
            title: title,
            package: pkg,
            numOfPkgs: amount,
            price: price
        });
    }

    public onAddClick(event: any) {
        const row = (event as HTMLElement).closest('tr');
        const cells = row ? Array.from(row.querySelectorAll('td')) : [];
        const input = cells[2]?.querySelector('input') as HTMLInputElement | null;
        var pkg = cells[0]?.textContent ?? '';
        var amount = input?.value;
        var price = cells[1]?.textContent ?? '';
        if (!amount) {
            modalService.launch('Ошибка', "Вы забыли ввести необходимое количество");
            return;
        }

        this.animateAdd(input, amount);

        this.addItem({
            catNum: this.catNum,
            title: this.title,
            package: pkg,
            numOfPkgs: parseInt(String(amount), 10),
            price: parseFloat(price) || 0
        });
    }

    public addItemToCart(event: any, pkg: string, price: number) {
        var amountEl = [...event.parentElement.childNodes].find(e => e?.classList?.contains('num-to-order'))
        const amount = parseInt(amountEl.value);
        if (!amount || isNaN(amount)) {
            modalService.launch('Ошибка', "Вы забыли ввести необходимое количество!");
            return;
        }

        this.animateAdd(amountEl, amount.toString());

        this.addItem({
            catNum: this.catNum,
            title: this.title,
            package: pkg,
            numOfPkgs: amount,
            price: price
        });
    }

    private animateAdd(el: Element | null, text: string) {
        const target = document.getElementById('cart_counter') ?? document.querySelector('.fa-shopping-basket');
        if (!el || !target || !el.animate) {
            return;
        }
        const from = el.getBoundingClientRect();
        const to = target.getBoundingClientRect();
        const clone = document.createElement('div');
        clone.className = 'title-1';
        clone.innerHTML = `<b>${text}</b>`;
        Object.assign(clone.style, {
            position: 'fixed',
            top: `${from.top}px`,
            left: `${from.left}px`,
            zIndex: '100',
            color: '#b76399',
            pointerEvents: 'none'
        });
        document.body.appendChild(clone);
        clone.animate([
            { transform: 'translate(0, 0)', fontSize: '' , opacity: 1 },
            { transform: `translate(${to.left - from.left + 10}px, ${to.top - from.top + 10}px)`, fontSize: '6px', opacity: 0 }
        ], { duration: 1000, easing: 'ease-in' }).onfinish = () => clone.remove();
    }

}

window.expertLabsCart = new ExpertLabsCart(); 